import Axios from 'axios';
import header from './auth/header';

const API_URL =  process.env.API_URL + '/api/v3/data/products/lending';
const API_URL_V3 = process.env.API_URL + '/api/v3/'
class ProductLending {
  indexAll() {
    return Axios.get(API_URL + ``);
  }
  
  listDetail(subBrandId){
    return Axios.get(API_URL + `/${subBrandId}`);
  }
  
  show(params = {}, productId){
    return Axios.get(API_URL_V3 + `product-lending/funder/${productId}`, {
      headers: header(),
      params: params
    });

  }

  storeLending(data){
    return Axios.post(API_URL_V3 + 'product-lending/funder', data, { headers: header() });
  }
  
  index(params = {}) {  
    return Axios.get(API_URL_V3 + 'product-lending/funder', {
      headers: header(),
      params: params
    });
  }

}

export default new ProductLending();



// WEBPACK FOOTER //
// ./src/api/produkLendingV3.js